// import i18n from '@/plugins/i18n'

export default [
  {
    portalGroup: 'press.public',
    path: 'P0101AuthorList/index',
    name: 'TTC PRESS Article Author',
    component: () => import('./PgMainPage')
  }
]
